<div class="tableContainer">
  <table class="resultTable">
    @if (title()) {
      <tr>
        <td class="headerCell center" colspan="3">{{ title() }}</td>
      </tr>
    }
    @for (row of rows(); track $index) {
      <tr>
        <td class="tableCell">{{ row.label }}</td>
        <td class="tableCell">{{ row.key }}</td>
        <td class="tableCell">{{ row.value }}</td>
      </tr>
    }
  </table>
</div>
